import React, { Component } from 'react';

class BuyScheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: props.width,
      height: props.height,
      places: props.places,
      avatar: [],
      selected: props.selected,
      scale: 1,
      minScale: 1,
      userScale: null,
      boxWidth: 0,
      preselected: [],
      minTicketPrice: null,
      maxTicketPrice: null,
    };
  }

  // Вешаем событие на ресайз окна
  componentDidMount() {
    this.resizeScheme(true);
    this.checkVip();
    dragscroll.reset();

    $(window).on('load resize orientationchange', this.resizeScheme);
  }

  componentWillReceiveProps(nextProps) {
    this.checkVip();
    this.setState({
      places: nextProps.places,
      selected: nextProps.selected,
      preselected: [],
    });
  }

  // Снимаем событие с ресайза окна
  componentWillUnmount() {
    $(window).off('load resize orientationchange', this.resizeScheme);
  }

  // Изменение масштаба
  resizeScheme = first => {
    // const { userScale, minScale } = this.state;
    const { scheme } = this;
    const contentWidth = $(scheme)
      .find('.scheme__body')
      .outerWidth();

    let { scale } = this.state;
    const boxWidth = $(scheme).outerWidth() - 17;

    if (boxWidth < contentWidth) {
      scale = boxWidth / contentWidth;
    }

    if (first) {
      const h =
        $(scheme)
          .find('.scheme__body')
          .outerHeight() * scale;

      $(scheme)
        .parents('.scheme-box')
        .css('maxHeight', h + 'px');
    }

    this.setState({
      boxWidth: boxWidth,
      scale: scale,
      minScale: scale,
    });
  };

  // Проверка вип-мест
  checkVip() {
    const object = this.state.places;
    let prices = [];

    object.forEach(ticket => {
      if (prices.length > 0) {
        prices.includes(ticket.price) ? null : prices.push(ticket.price);
      } else {
        prices.push(ticket.price);
      }
    });

    prices = prices.sort((a, b) => a - b);

    const minValue = obj => Math.min(...obj);
    const maxValue = obj => Math.max(...obj);

    let minPrice = null;
    let maxPrice = null;
    let midPrice = null;

    switch (prices.length) {
      // Если 2 цены
      case 2:
        minPrice = minValue(prices);
        maxPrice = maxValue(prices);
        break;
      // 3
      case 3:
        minPrice = minValue(prices);
        midPrice = prices[1];
        maxPrice = maxValue(prices);
      // Одна цена
      default:
        minPrice = prices[0];
        break;
    }

    this.setState({
      minTicketPrice: minPrice,
      midTicketPrice: midPrice,
      maxTicketPrice: maxPrice,
    });
  }

  // Клик на кнопки резайза
  changeScale(plus) {
    let newScale;

    if (plus) {
      if (this.state.userScale == null) {
        newScale = this.state.scale + 0.25;
      } else {
        newScale = this.state.userScale + 0.25;
      }

      if (newScale > 2) {
        newScale = 2;
      }

      this.setState({
        userScale: newScale,
      });
    } else {
      if (this.state.userScale == null) {
        newScale = this.state.scale - 0.25;
      } else {
        newScale = this.state.userScale - 0.25;
      }

      if (newScale < this.state.minScale) {
        newScale = this.state.minScale;
      }

      this.setState({
        userScale: newScale,
      });
    }
  }

  // Проверка на наличие аватарки
  checkAvatar = place_id => {
    const { avatar } = this.props;

    let img = null;

    Object.keys(avatar).forEach(item => {
      if (item == +place_id) {
        img = this.createAvatar(avatar[item]);
      }
    });

    return img;
  };

  // Создаем аватарку пользователя
  createAvatar = url => {
    return (
      <div
        className="place__avatar"
        style={{ backgroundImage: `url(${url})` }}
      />
    );
  };

  // Определяем тип билетов подороже
  checkVipType = (price, midPrice, maxPrice) => {
    switch (price) {
      case maxPrice:
        return 'true';
      case midPrice:
        return 'false';
      default:
        if (midPrice) return 'min';
        return 'false';
    }
  };

  render() {
    const {
      selected,
      preselected,
      maxTicketPrice,
      midTicketPrice,
    } = this.state;
    const { order, session, order_success, exit } = this.props;

    const maxPrice = maxTicketPrice;
    const midPrice = midTicketPrice;

    const places = this.state.places.map(place => {
      const checkAvatar = this.checkAvatar(place.id);

      if (place.status) {
        const classes = ['place'];

        if (order) {
          if (order.session_id === +session) {
            if (order.seats.indexOf(+place.id) !== -1) {
              classes.push('place--reserve');
            }
          }
        } else {
          // if (this.state.preselected.includes(place.id)) {
          if (preselected.indexOf(+place.id) !== -1) {
            classes.push('place--preselected');
          }

          // if (this.state.selected.includes(place.id)) {
          if (selected.indexOf(+place.id) !== -1) {
            classes.push('place--active');
          }
        }

        return (
          <a
            key={place.id}
            style={{ left: place.x + 'px', top: place.y + 'px' }}
            className={classes.join(' ')}
            data-sold="false"
            data-vip={this.checkVipType(place.price, midPrice, maxPrice)}
          >
            {place.place}
            <div className="popover">
              <span className="big">{place.price} ₽</span>
              <span>
                {place.row} ряд, {place.place} место
              </span>
            </div>
          </a>
        );
      } else {
        const classes = ['place'];

        let o = 'Занято';

        if (order) {
          if (order.session_id === +session) {
            if (order.seats.indexOf(+place.id) !== -1) {
              o = 'Забронировано';
              classes.push('place--reserve');
            }
          }
        }

        if (order_success) {
          if (order_success.seats.indexOf(+place.id) !== -1) {
            o = 'Ваш заказ';
            classes.push('place--buy');
          }

          order_success.seats.forEach(item => {
            if (item == +place.id) {
              classes.push('place--active');
            }
          });
        }

        return (
          <a
            key={place.id}
            style={{ left: place.x + 'px', top: place.y + 'px' }}
            className={classes.join(' ')}
            data-sold="true"
            data-vip={this.checkVipType(place.price, midPrice, maxPrice)}
          >
            {place.place}
            {checkAvatar}
            <div className="popover">
              <span>{o}</span>
            </div>
          </a>
        );
      }
    });

    const rowsY = {};

    this.state.places.forEach(item => {
      if (rowsY[item.row] == undefined) {
        rowsY[item.row] = item.y;
      }
    });

    const rows = [];

    Object.keys(rowsY).forEach(key => {
      const html = (
        <span
          key={key}
          className="place-row"
          style={{ top: rowsY[key] + 'px' }}
        >
          {key}
        </span>
      );
      rows.push(html);
    });

    const styles = {
      width: `${this.state.width}px`,
      height: `${this.state.height}px`,
    };

    let { scale } = this.state;

    if (this.state.userScale != null) {
      scale = this.state.userScale;

      if (this.state.userScale < this.state.minScale)
        scale = this.state.minScale;
    }

    const scaleStyles = {
      transform: `scale(${scale})`,
    };

    const padding = {
      paddingRight: !!('ontouchstart' in window) ? '17px' : '0',
    };

    // const pointer = {
    // 	pointerEvents: false ? 'none' : 'auto'
    // }

    const exitIcon = (
      <div
        className="place-exit"
        style={{
          top: `${exit.y}px`,
          left: `${exit.x}px`,
        }}
      />
    );

    return (
      <React.Fragment>
        <div
          className="scheme-box__inner dragscroll"
          ref={node => (this.scheme = node)}
          style={padding}
        >
          <div className="scheme">
            <div className="scheme__header">
              <div className="scheme-ticket">
                <div className="place place--active" />
                <span className="scheme-ticket__price">Ваш заказ</span>
              </div>
            </div>
            <div style={scaleStyles} className="scheme__body">
              <div style={styles}>
                <div className="place-rows" style={{ left: 0 }}>
                  {rows}
                </div>
                {exit ? exitIcon : null}
                {places}
                <div className="place-rows" style={{ right: 0 }}>
                  {rows}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scheme-box__controls">
          <div className="controls">
            <button
              className="control"
              type="button"
              onClick={() => this.changeScale(true)}
            >
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path d="M12 5h-3v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3v3c0 1.1.9 2 2 2s2-.9 2-2v-3h3c1.1 0 2-.9 2-2s-.9-2-2-2z" />
              </svg>
            </button>
            <button
              className="control"
              type="button"
              onClick={() => this.changeScale(false)}
            >
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path d="M12 5h-10c-1.1 0-2 .9-2 2s.9 2 2 2h10c1.1 0 2-.9 2-2s-.9-2-2-2z" />
              </svg>
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default BuyScheme;
